import React from 'react';
export function QueVasALograrSection() {
  return <section className="relative w-full text-white" style={{
    backgroundImage: "url('https://res.cloudinary.com/dd0wtuekk/image/upload/v1771285256/sporty_night_background_rlhcor.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '60px 20px'
  }} data-id="element-141">
      {/* Dark overlay */}
      <div className="absolute inset-0" style={{
      background: 'rgba(0,0,0,0.65)'
    }} data-id="element-142" />

      <div className="relative z-10 max-w-[600px] mx-auto" data-id="element-143">
        <h2 className="font-extrabold text-center" style={{
        fontSize: '22px',
        marginBottom: '24px'
      }} data-id="element-144">
          <span style={{
          position: 'relative',
          display: 'inline-block'
        }} data-id="element-145">
            <span style={{
            position: 'absolute',
            left: '-4px',
            right: '-4px',
            top: '20%',
            bottom: '10%',
            background: '#00E676',
            transform: 'rotate(-0.5deg)',
            borderRadius: '3px 2px 4px 2px',
            zIndex: -1,
            opacity: 0.85
          }} data-id="element-146" />
            ¿QUÉ LOGRARÁ TU HIJO?
          </span>
        </h2>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-147">
          ✔ Va a rendir en el partido como entrena en la semana. Por fin va a
          demostrar lo que sabe.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-148">
          ✔ Tu hijo va a recuperar la confianza y volverá a jugar con
          seguridad.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-149">
          ✔ Notará el cambio: dejará de esconderse y empezará a jugar como un
          líder.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-150">
          ✔ El entrenador va a empezar a verle distinto, más firme, más seguro,
          más líder.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-151"></p>

        <p style={{
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-152">
          ✔ Va a desarrollar constancia, enfoque y disciplina que le van a
          servir en el fútbol y en la vida.
        </p>
      </div>
    </section>;
}